import {RouteConfig} from "vue-router";
import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";

const routes: Array<RouteConfig> = [
  /**
   * sub categories
   */
  {
    path: "/admin/parent_categories",
    name: "ParentCategoryList",
    component: () => import("../views/ProductManagement/ParentCategory/ParentCategoryList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/parent_categories/add",
    name: "ParentCategoryAdd",
    component: () => import("../views/ProductManagement/ParentCategory/ParentCategoryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/parent_categories/:id/edit",
    name: "ParentCategoryEdit",
    component: () => import("../views/ProductManagement/ParentCategory/ParentCategoryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/parent_categories/:id/show",
    name: "ParentCategoryShow",
    component: () => import("../views/ProductManagement/ParentCategory/ParentCategoryShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

  /**
   * categories
   */
  {
    path: '/admin/ext-dotlines-admin/categories',
    name: 'Categories',
    component: () => import(/* webpackChunkName: "categories" */ '@/views/ProductManagement/Category/CategoryList.vue'),
    meta: {title: 'Categorys - Dotlines', requireAuth: true, layout: MasterLayout}
  },
  {
    path: '/admin/ext-dotlines-admin/categories/create',
    name: 'CategoryCreate',
    component: () => import(/* webpackChunkName: "category-create" */ '@/views/ProductManagement/Category/CategoryForm.vue'),
    meta: {requireAuth: true, layout: MasterLayout, title: 'Category create - Dotlines'}
  },
  {
    path: '/admin/ext-dotlines-admin/categories/:id/show',
    name: 'CategoryShow',
    component: () => import(/* webpackChunkName: "category-show" */ '@/views/ProductManagement/Category/CategoryShow.vue'),
    meta: {requireAuth: true, layout: MasterLayout, title: 'Category show - Dotlines'}
  },
  {
    path: '/admin/ext-dotlines-admin/categories/:id/edit',
    name: 'CategoryEdit',
    component: () => import(/* webpackChunkName: "category-edit" */ '@/views/ProductManagement/Category/CategoryForm.vue'),
    meta: {requireAuth: true, layout: MasterLayout, title: 'Category edit - Dotlines'}
  },

  /**
   * sub categories
   */
  {
    path: '/admin/ext-dotlines-admin/sub-categories',
    name: 'SubCategories',
    component: () => import(/* webpackChunkName: "sub-categories" */ '@/views/ProductManagement/SubCategory/SubCategoryList.vue'),
    meta: {title: 'Sub Category - Dotlines', requireAuth: true, layout: MasterLayout}
  },
  {
    path: '/admin/ext-dotlines-admin/sub-categories/create',
    name: 'SubCategoryCreate',
    component: () => import(/* webpackChunkName: "sub-category-create" */ '@/views/ProductManagement/SubCategory/SubCategoryForm.vue'),
    meta: {requireAuth: true, layout: MasterLayout, title: 'Sub Category create - Dotlines'}
  },
  {
    path: '/admin/ext-dotlines-admin/sub-categories/:id/show',
    name: 'SubCategoryShow',
    component: () => import(/* webpackChunkName: "sub-category-show" */ '@/views/ProductManagement/SubCategory/SubCategoryShow.vue'),
    meta: {requireAuth: true, layout: MasterLayout, title: 'Sub Category show - Dotlines'}
  },
  {
    path: '/admin/ext-dotlines-admin/sub-categories/:id/edit',
    name: 'SubCategoryEdit',
    component: () => import(/* webpackChunkName: "sub-category-edit" */ '@/views/ProductManagement/SubCategory/SubCategoryForm.vue'),
    meta: {requireAuth: true, layout: MasterLayout, title: 'Sub Category - Dotlines'}
  },
];

export default routes;
